<template>
  <div class="flex flex-col">
    <LabelReset
      :initialValue="initialShape"
      :modelValue="modelValue"
      @update:modelValue="setSelectedTableShape($event)"
    >
      Shape
    </LabelReset>
    <svg
      class="h-10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 37"
      preserveAspectRatio="xMinYMin meet"
    >
      <circle
        id="circle-shape"
        cx="18"
        cy="18"
        r="15"
        stroke-width="2"
        class="stroke-status-available cursor-pointer"
        :class="
          modelValue === TableShape.CIRCLE
            ? 'fill-surface-table-reserved'
            : 'fill-surface-table-available'
        "
        @click="setSelectedTableShape(TableShape.CIRCLE)"
      />
      <rect
        id="square-shape"
        x="45"
        y="5"
        width="27"
        height="27"
        rx="2"
        stroke-width="2"
        class="stroke-status-available cursor-pointer"
        :class="
          modelValue === TableShape.SQUARE
            ? 'fill-surface-table-reserved'
            : 'fill-surface-table-available'
        "
        @click="setSelectedTableShape(TableShape.SQUARE)"
      />

      <path
        id="triangle-shape"
        d="M 86 5 L 86 31 L 110 5 Z"
        stroke-width="2"
        class="stroke-status-available cursor-pointer"
        stroke-linejoin="round"
        :class="
          modelValue === TableShape.TRIANGLE
            ? 'fill-surface-table-reserved'
            : 'fill-surface-table-available'
        "
      />
      <!-- This is a transparent rectangle that is placed on top of the triangle shape to make areas outside of the triangle clickable -->
      <rect
        id="triangle-shape-clickable"
        x="86"
        y="5"
        width="24"
        height="26"
        class="fill-red-500 cursor-pointer"
        fill-opacity="0"
        @click="setSelectedTableShape(TableShape.TRIANGLE)"
      />

      <path
        id="half-circle-shape"
        d="M 124 5 C 145 5, 145 31, 124 31 Z"
        stroke-width="2"
        class="stroke-status-available cursor-pointer"
        stroke-linejoin="round"
        :class="
          modelValue === TableShape.HALF_CIRCLE
            ? 'fill-surface-table-reserved'
            : 'fill-surface-table-available'
        "
        @click="setSelectedTableShape(TableShape.HALF_CIRCLE)"
      />
    </svg>
  </div>
</template>

<script setup lang="ts">
import LabelReset from '@/common/components/molecules/LabelReset.vue'

import { TableShape, TableShapeType } from '@generated/types'

const emit = defineEmits<{
  // eslint-disable-next-line no-unused-vars
  (event: 'update:modelValue', value: TableShapeType): void
}>()

withDefaults(defineProps<{ modelValue: TableShapeType; initialShape?: TableShapeType }>(), {
  initialShape: undefined,
})

const setSelectedTableShape = (shape: TableShapeType) => {
  emit('update:modelValue', shape)
}
</script>
